import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";

// import { getAllCollaborationsCall } from "Common/Repository";
import { getAllCollaborationsCall } from "actions/collaborationsAction";

const initialState = {
    loading: false,
    collaborationsData: [],
    collaborationsCurrentPage: 1,
    collaborationsTotalPages: 0,
    error: null,
    success: false,
};

const collaborationsSlice = createSlice({
    name: 'collaborations',
    initialState,
    reducers: {
        setCollaborations: (state, action) => {
            state.collaborationsData = action.payload;
        },
        setCollaborationsCurrentPage: (state, action) => {
            state.collaborationsCurrentPage = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCollaborationsCall.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllCollaborationsCall.fulfilled, (state, action) => {
                state.collaborationsData = action.payload?.data?.data;
                state.collaborationsCurrentPage = action.payload?.data?.current_page;
                state.collaborationsTotalPages = action.payload?.data?.last_page;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAllCollaborationsCall.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(logout, (state) => {
                return initialState;
            })
    },
});

export const { setCollaborations, setCollaborationsCurrentPage } = collaborationsSlice.actions;
export default collaborationsSlice.reducer;
